export const createChannel = () => {
	const channel = new MessageChannel()
	const hostPort = channel.port1
	const remotePort = channel.port2

	hostPort.onmessage = () => {}

	return { hostPort, remotePort }
}
